<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Documents">
                          Documents
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Duties of an Electricity Consumer</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
          <div class="cntnt">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">Duties of an Electricity Consumer</h1>
              </b-col>
           </b-row>

                  <p class="content">
                    <ul class="a">
                   <li>Use energy efficient appliances to reduce energy consumption. Energy saved is energy produced.</li>
                   <li>Pay electricity bills regularly to enable APDCL to provide continuous and reliable power supply. Pay at APDCL authorised cash counters only or through online mode at www.apdcl.org or any other mode approved by APDCL and get proper receipts.</li>
                   <li>Maintain proper safety of all electrical appliances. Always, install safety equipment like Earth leakage / overload & short circuit protection (circuit breakers / switches) near point of supply.</li>
                   <li>Report electrical accidents and take necessary precautions to avoid such accidents. Take extra safety measure during natural calamities to avoid any mishap arising out of broken lines etc.</li>
                   <li>Cooperate with the APDCL&apos;s personnel and make the premises available to them for carrying out their duty to enable APDCL to provide better service.</li>
                   <li>Provide and maintain sufficient protection to the metering and associated equipment to the satisfaction of APDCL.</li>
                   <li>Do not tamper or permit tamper, distress or damage the electrical plant, lines or metering equipment provided by APDCL.</li>
                   <li>If the consumer discovers that the protective seal of the metering equipment has been broken, he shall notify APDCL immediately.</li>
                   <li>Do not interfere with the supply mains or apparatus including the metering arrangement which may have been installed in his premises.</li>
                   <li>Ensure healthy earthing is installed at your premises.</li>
                   <li>Ensure only IS marked cables of proper capacity are used for your installation and get the wiring done through only licensed Electrical Contractors.</li>
                   <li>Always use proper capacity fuse wire in main switches.</li>
                   <li>To get proper voltage, install adequate capacitors for inductive loads.</li>
                   <li>Ensure safety of energy meter and metering equipment in your premises. Provide weather Proof enclosures to meters and metering equipment.</li>
                   <li>Ensure that the licensed electrical wiring contractor or his authorised representative is present in your premises at the time of effecting supply for testing the installation.</li>
                   <li>Provide space for fixing the meter at a convenient place in the ground floor for easy accessibility to the Assessor for taking meter reading.</li>
                   <li>In multi-storied buildings, irrespective of the number of floors, provide space for fixing meter, cut -out etc., in the ground floor only.</li>
                   <li>While connecting additional loads like lights, fans, etc., and other electric appliances such as refrigerators, air-conditioners, Water-heaters etc., ensure that the meter capacity is adequate.</li>
                   <li>If the meter capacity is not adequate, contact the concerned Sub-Division Officials for installing higher capacity meter.</li>
                   <li>Use electricity only for purpose for which the service connection has been given.</li>
                   <li>Construct your building with proper clearance from the existing High Tension/Low Tension lines as per the Indian Electricity Rules 1956.(vide rule 79 & 80)</li>
                   <li>If the building does not have adequate frontage and the line has to go through or over the adjoining premises of other owners arrange for necessary way-leave at your own cost for running the lines.</li>
                   <li>Get your supply converted from single-phase to three phase if the total connected load exceeds 4000 watts i.e. 4 KW.</li>
                   <li>Promptly replace promptly defective electrical fittings and appliances.</li>
                   <li>If the meter is found to be defective and not running, bring the matter to the notice of the Sub-Division officials in writing for replacement by a healthy meter.</li>
                   <li>Get the internal wiring checked up periodically not only to avoid leakage of electricity but also to safeguard the lives of the inmates in the premises.</li>
                    </ul>
                  </p>
                </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import Cards from '@/components/DocumentCardComponents.vue'
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'


export default {
  name: 'Document',
  components: {
    'Cards' : Cards,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
  }
}
</script>

<style scoped="true">
li{
  padding:0;
}
ul.a {
  list-style-type: circle;
  padding-left:30px;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
